const LANGUAGE_STORAGE_KEY = "tint-admin-language"
const USER_CHOICE_KEY = "tint-admin-user-language-choice"

export const LanguageService = {
  // Get saved language from localStorage
  getSavedLanguage(): string | null {
    return localStorage.getItem(LANGUAGE_STORAGE_KEY)
  },

  // Save language to localStorage
  saveLanguage(language: string): void {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language)
  },

  // Check if user has made a direct language choice
  hasUserMadeChoice(): boolean {
    return localStorage.getItem(USER_CHOICE_KEY) === "true"
  },

  // Mark that user has made a direct language choice
  markUserChoice(): void {
    localStorage.setItem(USER_CHOICE_KEY, "true")
  },

  // Clear user choice (for testing or reset)
  clearUserChoice(): void {
    localStorage.removeItem(USER_CHOICE_KEY)
  },

  // Get default language based on integration type
  getDefaultLanguage(integrationType: string): string {
    return integrationType === "TIENDANUBE" ? "pt" : "en"
  },
}
